import { ClientWalkInComponent } from './transaction/clientWalkIn/clientWalkIn.component';
import { AddClientWalkInComponent } from './transaction/clientWalkIn/addClientWalkIn.component';
import { ClientSearchComponent } from './common/clientSearch.component';
import { FollowUpComponent } from './transaction/followUp/followUp.component';
import { FollowUpWindowComponent } from './transaction/followUp/followUpWindow.component';
import { FollowUpCalendarModalComponent } from './transaction/followUp/followUpCalendarModal.component';
import { BranchMasterComponent } from './master/branch/branch.component';
import { EmployeeMasterComponent } from './master/employee/employee.component';
import { AddEditEmployeeComponent } from './master/employee/addEditEmployee.component';
import { ClientMasterComponent } from './master/client/client.component';
import { AddEditClientComponent } from './master/client/addEditClient.component';
import { ReferenceMasterComponent } from './master/reference/reference.component';
import { AddEditReferenceComponent } from './master/reference/addEditReference.component';
import { PocMasterComponent } from './master/poc/poc.component';
import { AddEditPocComponent } from './master/poc/addEditPoc.component';
import { HearinglossMasterComponent } from './master/hearingLoss/hearingloss.component';
import { AddEditHearinglossComponent } from './master/hearingLoss/addEditHearingloss.component';
import { BrandMasterComponent } from './master/brand/brand.component';
import { AddEditBrandComponent } from './master/brand/addEditBrand.component';
import { BrandmodelMasterComponent } from './master/brandModel/brandmodel.component';
import { AddEditBrandmodelComponent } from './master/brandModel/addEditBrandmodel.component';
import { HamodelMasterComponent } from './master/hamodel/hamodel.component';
import { AddEditHamodelComponent } from './master/hamodel/addEditHamodel.component';
import { clientOutComponent } from './common/clientOut.component';
import { clientDetailsComponent } from './common/clientDetails.component';
import { AddEditBranchComponent } from './master/branch/addEditBranch.component';
import { PurchasePartyMasterComponent } from './master/purchaseParty/purchaseParty.component';
import { AddEditPurchasePartyComponent } from './master/purchaseParty/addEditPurchaseParty.component';
import { StockinMasterComponent } from './master/stockIn/stockIn.component';
import { ClientServiceSearchComponent } from './common/clientServiceSearch.component';
import { FamilyMasterComponent } from './master/family/family.component';
import { AddEditFamilyComponent } from './master/family/addEditFamily.component';
import { UserMasterComponent } from './master/userMaster/userList.component';
import { AddEditUserComponent } from './master/userMaster/addEditUser.component';
import { DoctorUserMasterComponent } from './master/doctorUserMaster/doctorUserList.component';
import { AddEditDoctorUserComponent } from './master/doctorUserMaster/addEditDoctorUser.component';
import { PurchaseInvoiceSearchComponent } from './common/purchaseInvoiceSearch.component';

import { TestingBillComponent } from './transaction/testingBill/testingBill.component';
import { AddEditTestingBillComponent } from './transaction/testingBill/addEditTestingBill.component';
import { ChallanOutComponent } from './transaction/challanOut/challanOut.component';
import { AddEditChallanOutComponent } from './transaction/challanOut/addEditChallanOut.component';
import { ChallanInComponent } from './transaction/challanIn/challanIn.component';
import { AddEditChallanInComponent } from './transaction/challanIn/addEditChallanIn.component';
import { TransferChallanOutComponent } from './transaction/transferChallanOut/transferChallanOut.component';
import { AddTransferChallanOutComponent } from './transaction/transferChallanOut/addTransferChallanOut.component';
import { TransferChallanInComponent } from './transaction/transferChallanIn/transferChallanIn.component';
import { AddTransferChallanInComponent } from './transaction/transferChallanIn/addTransferChallanIn.component';
import { SalesBillentryComponent } from './transaction/salesBillentry/salesBillentry.component';
import { AddEditSalesBillentryComponent } from './transaction/salesBillentry/addEditSalesBillentry.component';
import { TestingTrailComponent } from './transaction/testingTrail/testingTrail.component';
import { AddTestingComponent } from './transaction/testingTrail/addTesting.component';
import { AddTrailComponent } from './transaction/testingTrail/addTrail.component';
import { AddEditEmiDetailsComponent } from './transaction/salesBillentry/addEditEmiDetails.component';
import { AddServiceTestingComponent } from './transaction/testingTrail/addServiceTesting.component';
import { ServiceWalkInComponent } from './transaction/serviceWalkIn/serviceWalkIn.component';
import { AddServiceWalkInComponent } from './transaction/serviceWalkIn/addServiceWalkIn.component';
import { AddServiceEntryComponent } from './transaction/testingTrail/addServiceEntry.component';
import { AddBillEntryComponent } from './transaction/serviceWalkIn/addBillEntry.component';
import { AddImportExportComponent } from './transaction/serviceWalkIn/addImportExport.component';
import { AddDropReasonComponent } from './transaction/serviceWalkIn/addDropReason.component';
import { TestBillGenerationComponent } from './transaction/clientWalkIn/testBillGeneration.component';
import { SalesReturnComponent } from './transaction/salesReturn/salesReturn.component';
import { AddSalesReturnComponent } from './transaction/salesReturn/addSalesReturn.component';
import { AdvanceReturnComponent } from './transaction/advanceReturn/advanceReturn.component';
import { AddAdvanceReturnComponent } from './transaction/advanceReturn/addAdvanceReturn.component';
import { ClientAdvanceServiceSearchComponent } from './common/clientAdvanceServiceSearch.component';
import { CashPaymentComponent } from './transaction/cashPayment/cashPayment.component';
import { CashReceiptComponent } from './transaction/cashReceipt/cashReceipt.component';
import { AddEditCashReceiptComponent } from './transaction/cashReceipt/addEditCashReceipt.component';
import { PhClientMasterComponent } from './master/phClient/phClient.component';
import { AddEditphClientComponent } from './master/phClient/addEditphClient.component';
import { PurchaseInvoiceComponent } from './transaction/purchaseInvoice/purchaseInvoice.component';
import { AddEditPurchaseInvoiceComponent } from './transaction/purchaseInvoice/addEditPurchaseInvoice.component';
import { ServiceInvoiceComponent } from './transaction/serviceInvoice/serviceInvoice.component';
import { AddEditServiceInvoiceComponent } from './transaction/serviceInvoice/addEditServiceInvoice.component';
import { PurchaseReturnComponent } from './transaction/purchaseReturn/purchaseReturn.component';
import { AddPurchaseReturnComponent } from './transaction/purchaseReturn/addPurchaseReturn.component';
import { NewPurchaseReturnComponent } from './transaction/newPurchaseReturn/newPurchaseReturn.component';
import { AddEditNewPurchaseReturnComponent } from './transaction/newPurchaseReturn/addEditNewPurchaseReturn.component';
import { ChangeSerialComponent } from './transaction/advanceReturn/changeSerial.component';
import { AddServiceClientComponent } from './transaction/serviceWalkIn/addServiceClient.component';
import { ServicePhoneTrackingComponent } from './transaction/serviceWalkIn/servicePhoneTracking.component';
import { clientHistoryComponent } from './common/clientHistory';
import { trackHistoryComponent } from './common/trackHistory';
import { HVPhoneBillComponent } from './transaction/hvphonebill/hvphonebill.component';
import { ReportsComponent } from './reports/reports.component';
import { HVEditComponent } from './transaction/Edit/hvedit/hvedit.component';
import { HVAddEditComponent } from './transaction/Edit/hvedit/addedithv.component';
import { SOAEditComponent } from './transaction/Edit/soaedit/soaedit.component';
import { SOAAddEditComponent } from './transaction/Edit/soaedit/addeditsoa.component';
import { followUpClientUploadComponent } from './transaction/followUpClientUpload/followUpClientUpload.component';
import { menuMappingComponent } from './master/menuMapping/menuMapping.component';
import { ClientConversionComponent } from './transaction/clientConversion/clientConversion.component';
import { branchwiseCACComponent } from './management/branchwise_cac/branchwiseCAC.component';
import { branchwiseCACMonthComponent } from './management/branchwise_cac_month/branchwiseCACMonth.component';
import { ProTaskRemainderComponent } from './transaction/proTaskRemainder/proTaskRemainder.component';
import { dynamicGridComponent } from './common/dynamicGrid.component';
import { branchMeetingComponent } from './management/branch-meeting/branchMeeting.component';
import { smsPanelComponent } from './master/smsPanel/smsPanel.component';
import { clientDocumentComponent } from './common/clientDocument.component';
import { SpareClientComponent } from './common/spareClient.component';
import { serviceReplyComponent } from './transaction/serviceWalkIn/serviceReply.component';
import { getBillDiscountApproval } from './transaction/getBillDiscountApproval/getBillDiscountApproval.component';
import { discountApprovalComponent } from './transaction/getBillDiscountApproval/discountApproval.component';
import { dataComparisonComponent } from './common/dataComparison.component';
import { BackupFollowUpClientComponent } from './transaction/backupFollowUpClient/backupFollowUpClient.component';
import {
    addCourierDetailsComponent
} from './transaction/serviceWalkIn/addCourierDetails.component';
import {
    VoucherTransactionComponent
} from './dataCorrection/voucherDetails/voucher.component';
import { ClientRejectTransactionComponent } from './dataCorrection/client_reject/client.component';
import { BillingDeleteComponent } from './dataCorrection/deleteBilling/deleteBilling.component';
import { VoucherDateChangeComponent } from './dataCorrection/walkin_trail_testing/datechange.component';
import { AddUpdateStockComponent } from './dataCorrection/stockUpdate/stocklist.component';
import { ClientWalkinDeleteComponent } from './dataCorrection/walkin_entry_delete/walkindelete.component';
import { from } from 'rxjs/observable/from';
import { AppointmentComponent } from './transaction/appointment/appointment.component';
import { CashOutComponent } from './transaction/cashOut/cashOut.component';
import { AddCashOutComponent } from './transaction/cashOut/addCashOut.component';
import { CashInComponent } from './transaction/cashIn/cashIn.component';
import { AddCashInComponent } from './transaction/cashIn/addCashIn.component';
import { ExpenseComponent } from './transaction/expense/expense.component';
import { AddExpenseComponent } from './transaction/expense/addExpense.component';
import { ClientWalkinTestingDetComponent } from './dataCorrection/walkintestingupdation/walkintestingupdation.component';
import { mergeReferenceComponent } from './master/reference/mergeReference.component';
import { AddEditSeriesComponent } from './master/series/addEditSeries.component';
import { seriesMasterComponent } from './master/series/series.component';
import { AddEditPowerComponent } from './master/power/addEditPower.component';
import { powerMasterComponent } from './master/power/power.component';
import { AddEditPerformanceComponent } from './master/performance/addEditPerformance.component';
import { performanceMasterComponent } from './master/performance/performance.component';
import { AddEditDesignComponent } from './master/design/addEditDesign.component';
import { designMasterComponent } from './master/design/design.component';
import { batteryMasterComponent } from './master/battery/battery.component';
import { AddEditBatteryComponent } from './master/battery/addEditBattery.component';
import { AddEditHSNComponent } from './master/hsncode/addEditHsn.component';
import { hsnMasterComponent } from './master/hsncode/hsn.component';
import { machineReturnApprovalComponent } from './transaction/salesReturn/machineReturnApproval.component';
import { clientHistoryDeleteComponent } from './dataCorrection/client_history/client_history.component';
import { FollowupChangeComponent } from './dataCorrection/followupChange/followupChange.component';
import { AiLeadEntryComponent } from './dataCorrection/aiLeadEntry/aiLeadEntry.component';
import { SharyxCallHistoryComponent } from './reports/sharyxCallHistory/sharyxCallHistory.component';
import { SharyxWhatsappResponseComponent } from './reports/sharyxWhatsappResponse/sharyxWhatsappResponse.component';
import { AiStatusMasterComponent } from './master/aiStatus/aiStatus.component';
import { AddEditAiStatusComponent } from './master/aiStatus/addEditAiStatus.component';
import { AiCallConfigMasterComponent } from './master/aiCallConfig/aiCallConfig.component';
import { AddEditAiCallConfigComponent } from './master/aiCallConfig/addEditAiCallConfig.component';
import { AiFollowupConfigMasterComponent } from './master/aiFollowupConfig/aiFollowupConfig.component';
import { AddEditAiFollowupConfigComponent } from './master/aiFollowupConfig/addEditAiFollowupConfig.component';
import { AiTrackDayMasterComponent } from './master/aiTrackDay/aiTrackDay.component';
import { AddEditAiTrackDayComponent } from './master/aiTrackDay/addEditAiTrackDay.component';
import { AiSettingsMasterComponent } from './master/aiSettings/aiSettings.component';
import { Dashboard } from './home/dashboard.component';
import { trailModelDetComponent } from './common/trailModalDet.component';
import { CustomerSatisfiedApprovalComponent } from './transaction/customerSatisfiedApproval/customerSatisfiedApproval.component';
import { AddEditPartyNameComponent } from './master/partyName/addEditPartyName.component';
import { PartyNameMasterComponent } from './master/partyName/partyName.component';
import { CouponPointsMasterComponent } from './master/couponPoints/couponPoints.component';
import { AddEditCouponPointsComponent } from './master/couponPoints/addEditCouponPoints.component';
import { DoctorMasterComponent } from './master/doctor/doctor.component';
import { AddEditDoctorComponent } from './master/doctor/addEditDoctor.component';
import { LedgerMasterComponent } from './master/ledgerMaster/ledgerMaster.component';
import { AddEditLedgerMasterComponent } from './master/ledgerMaster/addEditLedgerMaster.component';
import { ExpenseTypeMasterComponent } from './master/expenseType/expenseType.component';
import { AddEditExpenseTypeComponent } from './master/expenseType/addEditExpenseType.component';
import { OctTypeMasterComponent } from './master/octType/octType.component';
import { AddEditOctTypeComponent } from './master/octType/addEditOctType.component';
import { DoctorIncentiveMasterComponent } from './master/doctorIncentive/doctorIncentive.component';
import { AddEditDoctorIncentiveComponent } from './master/doctorIncentive/addEditDoctorIncentive.component';
import { DoctorIncentiveTestingMasterComponent } from './master/doctorIncentiveTesting/doctorIncentiveTesting.component';
import { AddEditDoctorIncentiveTestingComponent } from './master/doctorIncentiveTesting/addEditDoctorIncentiveTesting.component';
import { UnsoldDescriptionMasterComponent } from './master/unsoldDescription/unsoldDescription.component';
import { AddEditUnsoldDescriptionComponent } from './master/unsoldDescription/addEditUnsoldDescription.component';
import { HaModelColorMasterComponent } from './master/haModelColor/haModelColor.component';
import { AddEditHaModelColorComponent } from './master/haModelColor/addEditHaModelColor.component';
import { PromoTypeMasterComponent } from './master/promoType/promoType.component';
import { AddEditPromoTypeComponent } from './master/promoType/addEditPromoType.component';
import { PromoReferenceMasterComponent } from './master/promoReference/promoReference.component';
import { AddEditPromoReferenceComponent } from './master/promoReference/addEditPromoReference.component';
import { CouponCodeMasterComponent } from './master/couponCode/couponCode.component';
import { AddEditCouponCodeComponent } from './master/couponCode/addEditCouponCode.component';
import { TransferCouponCodeComponent } from './transaction/transferCouponCode/transferCouponCode.component';
import { AddEditTransferCouponCodeComponent } from './transaction/transferCouponCode/addEditTransferCouponCode.component';
import { CouponCodeClientComponent } from './transaction/couponCodeClient/couponCodeClient.component';
import { AddEditCouponCodeClientComponent } from './transaction/couponCodeClient/addEditCouponCodeClient.component';
import { CampPromoUploadComponent } from './transaction/campPromoUpload/campPromoUpload.component';
import { UpdateLeadsComponent } from './dataCorrection/updateLeads.component';
import { TallySyncStatusComponent } from './dataCorrection/tallySyncStatus/tallySyncStatus.component';
import { TelecallerMasterComponent } from './master/telecallerMaster/telecallerMaster.component';
import { AddEditTelecallerComponent } from './master/telecallerMaster/addEditTelecaller.component';
import { TelecallerSlotMasterComponent } from './master/telecallerSlotMaster/telecallerSlotMaster.component';
import { AddEditTelecallerSlotComponent } from './master/telecallerSlotMaster/addEditTelecallerSlot.component';
import { AssignTelecallerComponent } from './transaction/assignTelecaller/assignTelecaller.component';
import { TelecallerTempAssignComponent } from './transaction/telecallerTempAssign/telecallerTempAssign.component';
import { WalkinApprovalComponent } from './transaction/walkinApproval/walkinApproval.component';
import { PhoneTrackingFollowupChangeComponent } from './reports/phoneTrackingFollowupChange/phoneTrackingFollowupChange.component';
import { ClientOutPendingReportComponent } from './reports/clientOutPendingReport/clientOutPendingReport.component';

export const APP_COMPONENTS: any[] = [
    ClientWalkInComponent,
    PurchaseInvoiceSearchComponent,
    AddClientWalkInComponent,
    ClientSearchComponent,
    FollowUpComponent,
    FollowUpWindowComponent,
    FollowUpCalendarModalComponent,
    BranchMasterComponent,
    EmployeeMasterComponent,
    AddEditEmployeeComponent,
    ClientMasterComponent,
    AddEditClientComponent,
    ReferenceMasterComponent,
    AddEditReferenceComponent,
    PocMasterComponent, AddEditPocComponent,
    HearinglossMasterComponent, AddEditHearinglossComponent,
    BrandMasterComponent, AddEditBrandComponent,
    BrandmodelMasterComponent, AddEditBrandmodelComponent,
    HamodelMasterComponent, AddEditHamodelComponent,
    clientOutComponent,
    clientDetailsComponent,
    PurchasePartyMasterComponent, AddEditPurchasePartyComponent,
    StockinMasterComponent,
    ClientServiceSearchComponent,
    FamilyMasterComponent, AddEditFamilyComponent,
    UserMasterComponent, AddEditUserComponent,
    DoctorUserMasterComponent, AddEditDoctorUserComponent,

    TestingBillComponent, AddEditTestingBillComponent,
    ChallanOutComponent, AddEditChallanOutComponent,
    ChallanInComponent, AddEditChallanInComponent,
    TransferChallanInComponent, AddTransferChallanInComponent,
    TransferChallanOutComponent, AddTransferChallanOutComponent,
    SalesBillentryComponent, AddEditSalesBillentryComponent,
    AddEditEmiDetailsComponent,
    TestingTrailComponent, AddTestingComponent, AddTrailComponent,
    AddEditBranchComponent, AddServiceTestingComponent,
    ServiceWalkInComponent, AddServiceWalkInComponent, AddServiceEntryComponent,
    AddBillEntryComponent, AddImportExportComponent, AddDropReasonComponent,
    SalesReturnComponent, AddSalesReturnComponent,
    AdvanceReturnComponent, AddAdvanceReturnComponent,
    TestBillGenerationComponent, ClientAdvanceServiceSearchComponent,
    CashPaymentComponent, CashReceiptComponent, AddEditCashReceiptComponent,
    PhClientMasterComponent, AddEditphClientComponent,
    PurchaseInvoiceComponent, AddEditPurchaseInvoiceComponent,
    ServiceInvoiceComponent, AddEditServiceInvoiceComponent,
    PurchaseReturnComponent, AddPurchaseReturnComponent,
    NewPurchaseReturnComponent, AddEditNewPurchaseReturnComponent,
    ChangeSerialComponent, AddServiceClientComponent,
    ServicePhoneTrackingComponent,
    ReportsComponent,
    clientHistoryComponent,
    trackHistoryComponent,
    HVPhoneBillComponent,
    HVEditComponent,
    HVAddEditComponent,
    SOAEditComponent,
    SOAAddEditComponent,
    followUpClientUploadComponent,
    menuMappingComponent,
    ClientConversionComponent,
    branchwiseCACComponent,
    branchwiseCACMonthComponent,
    ProTaskRemainderComponent,
    dynamicGridComponent,
    branchMeetingComponent,
    smsPanelComponent,
    clientDocumentComponent,
    SpareClientComponent,
    serviceReplyComponent,
    getBillDiscountApproval,
    discountApprovalComponent,
    dataComparisonComponent,
    BackupFollowUpClientComponent,
    addCourierDetailsComponent,
    VoucherTransactionComponent,
    ClientRejectTransactionComponent,
    Dashboard,
    BillingDeleteComponent,
    VoucherDateChangeComponent,
    AppointmentComponent,
    CashOutComponent, AddCashOutComponent,
    CashInComponent, AddCashInComponent,
    ExpenseComponent, AddExpenseComponent,
    AddUpdateStockComponent,
    FollowupChangeComponent,
    ClientWalkinDeleteComponent,
    ClientWalkinTestingDetComponent, mergeReferenceComponent,
    AddEditSeriesComponent,
    seriesMasterComponent,
    powerMasterComponent,
    AddEditPowerComponent,
    performanceMasterComponent,
    AddEditPerformanceComponent,
    designMasterComponent,
    AddEditDesignComponent,
    AddEditBatteryComponent,
    batteryMasterComponent,
    hsnMasterComponent,
    AddEditHSNComponent,
    machineReturnApprovalComponent,
    clientHistoryDeleteComponent,
    trailModelDetComponent,
    CustomerSatisfiedApprovalComponent,
    AddEditPartyNameComponent,
    PartyNameMasterComponent,
    CouponPointsMasterComponent,
    AddEditCouponPointsComponent,
    DoctorMasterComponent,
    AddEditDoctorComponent,
    LedgerMasterComponent,
    AddEditLedgerMasterComponent,
    ExpenseTypeMasterComponent,
    AddEditExpenseTypeComponent,
    OctTypeMasterComponent,
    AddEditOctTypeComponent,
    DoctorIncentiveMasterComponent,
    AddEditDoctorIncentiveComponent,
    DoctorIncentiveTestingMasterComponent,
    AddEditDoctorIncentiveTestingComponent,
    UnsoldDescriptionMasterComponent,
    AddEditUnsoldDescriptionComponent,
    HaModelColorMasterComponent,
    AddEditHaModelColorComponent,
    PromoTypeMasterComponent,
    AddEditPromoTypeComponent,
    PromoReferenceMasterComponent,
    AddEditPromoReferenceComponent,
    CouponCodeMasterComponent,
    AddEditCouponCodeComponent,
    TransferCouponCodeComponent,
    AddEditTransferCouponCodeComponent,
    CouponCodeClientComponent,
    AddEditCouponCodeClientComponent,
    CampPromoUploadComponent,
    UpdateLeadsComponent,
    TallySyncStatusComponent,
    TelecallerMasterComponent,
    AddEditTelecallerComponent,
    TelecallerSlotMasterComponent,
    AddEditTelecallerSlotComponent,
    AssignTelecallerComponent,
    TelecallerTempAssignComponent,
    AiLeadEntryComponent,
    SharyxCallHistoryComponent,
    SharyxWhatsappResponseComponent,
    AiStatusMasterComponent,
    AddEditAiStatusComponent,
    AiCallConfigMasterComponent,
    AddEditAiCallConfigComponent,
    AiFollowupConfigMasterComponent,
    AddEditAiFollowupConfigComponent,
    AiTrackDayMasterComponent,
    AddEditAiTrackDayComponent,
    AiSettingsMasterComponent,
    PhoneTrackingFollowupChangeComponent,
    ClientOutPendingReportComponent,
    WalkinApprovalComponent,
];

export * from './common/purchaseInvoiceSearch.component';
export * from './transaction/clientWalkIn/clientWalkIn.component';
export * from './transaction/clientWalkIn/addClientWalkIn.component';
export * from './common/clientSearch.component';
export * from './transaction/followUp/followUp.component';
export * from './transaction/followUp/followUpWindow.component';
export * from './transaction/followUp/followUpCalendarModal.component';
export * from './master/branch/branch.component';
export * from './master/employee/employee.component';
export * from './master/employee/addEditEmployee.component';
export * from './master/client/client.component';
export * from './master/client/addEditClient.component';
export * from './master/reference/reference.component';
export * from './master/reference/addEditReference.component';
export * from './master/poc/poc.component';
export * from './master/poc/addEditPoc.component';
export * from './master/hearingLoss/hearingloss.component';
export * from './master/hearingLoss/addEditHearingloss.component';
export * from './master/brand/brand.component';
export * from './master/brand/addEditBrand.component';
export * from './master/brandModel/brandmodel.component';
export * from './master/brandModel/addEditBrandmodel.component';
export * from './master/hamodel/hamodel.component';
export * from './master/hamodel/addEditHamodel.component';
export * from './common/clientOut.component';
export * from './common/clientDetails.component';
export * from './master/branch/addEditBranch.component';
export * from './master/purchaseParty/purchaseParty.component';
export * from './master/purchaseParty/addEditPurchaseParty.component';
export * from './master/stockIn/stockIn.component';
export * from './master/family/family.component';
export * from './master/family/addEditFamily.component';
export * from './master/userMaster/userList.component';
export * from './master/userMaster/addEditUser.component';
export * from './master/doctorUserMaster/doctorUserList.component';
export * from './master/doctorUserMaster/addEditDoctorUser.component';
export * from './master/phClient/phClient.component';
export * from './master/phClient/addEditphClient.component';
export * from './master/partyName/addEditPartyName.component';
export * from './master/partyName/partyName.component';

export * from './transaction/testingBill/testingBill.component';
export * from './transaction/testingBill/addEditTestingBill.component';
export * from './transaction/challanOut/challanOut.component';
export * from './transaction/challanOut/addEditChallanOut.component';
export * from './transaction/challanIn/challanIn.component';
export * from './transaction/challanIn/addEditChallanIn.component';
export * from './transaction/transferChallanIn/transferChallanIn.component';
export * from './transaction/transferChallanIn/addTransferChallanIn.component';
export * from './transaction/transferChallanOut/transferChallanOut.component';
export * from './transaction/transferChallanOut/addTransferChallanOut.component';
export * from './transaction/salesBillentry/salesBillentry.component';
export * from './transaction/salesBillentry/addEditSalesBillentry.component';
export * from './transaction/testingTrail/testingTrail.component';
export * from './transaction/testingTrail/addTesting.component';
export * from './transaction/testingTrail/addTrail.component';
export * from './transaction/salesBillentry/addEditEmiDetails.component';
export * from './transaction/testingTrail/addServiceTesting.component';
export * from './transaction/serviceWalkIn/serviceWalkIn.component';
export * from './transaction/serviceWalkIn/addServiceWalkIn.component';
export * from './common/clientServiceSearch.component';
export * from './transaction/testingTrail/addServiceEntry.component';
export * from './transaction/serviceWalkIn/addBillEntry.component';
export * from './transaction/serviceWalkIn/addImportExport.component';
export * from './transaction/serviceWalkIn/addCourierDetails.component';
export * from './transaction/serviceWalkIn/addDropReason.component';
export * from './transaction/clientWalkIn/testBillGeneration.component';
export * from './transaction/salesReturn/salesReturn.component';
export * from './transaction/salesReturn/addSalesReturn.component';
export * from './transaction/advanceReturn/advanceReturn.component';
export * from './transaction/advanceReturn/addAdvanceReturn.component';
export * from './common/clientAdvanceServiceSearch.component';
export * from './transaction/cashPayment/cashPayment.component';
export * from './transaction/cashReceipt/cashReceipt.component';
export * from './transaction/cashReceipt/addEditCashReceipt.component';
export * from './transaction/purchaseInvoice/purchaseInvoice.component';
export * from './transaction/purchaseInvoice/addEditPurchaseInvoice.component';
export * from './transaction/serviceInvoice/serviceInvoice.component';
export * from './transaction/serviceInvoice/addEditServiceInvoice.component';
export * from './transaction/purchaseReturn/purchaseReturn.component';
export * from './transaction/purchaseReturn/addPurchaseReturn.component';
export * from './transaction/newPurchaseReturn/newPurchaseReturn.component';
export * from './transaction/newPurchaseReturn/addEditNewPurchaseReturn.component';
export * from './transaction/advanceReturn/changeSerial.component';
export * from './transaction/serviceWalkIn/addServiceClient.component';
export * from './transaction/serviceWalkIn/servicePhoneTracking.component';
export * from './transaction/hvphonebill/hvphonebill.component';

export * from './reports/reports.component';
export * from './common/clientHistory';
export * from './transaction/Edit/hvedit/hvedit.component';
export * from './transaction/Edit/hvedit/addedithv.component';
export * from './transaction/Edit/soaedit/soaedit.component';
export * from './transaction/Edit/soaedit/addeditsoa.component';
export * from './transaction/followUpClientUpload/followUpClientUpload.component';
export * from './master/menuMapping/menuMapping.component';
export * from './transaction/clientConversion/clientConversion.component';
export * from './management/branchwise_cac/branchwiseCAC.component';
export * from './management/branchwise_cac_month/branchwiseCACMonth.component';
export * from './transaction/proTaskRemainder/proTaskRemainder.component';
export * from './common/dynamicGrid.component';
export * from './management/branch-meeting/branchMeeting.component';
export * from './master/smsPanel/smsPanel.component';
export * from './common/clientDocument.component';
export * from './common/spareClient.component';
export * from './transaction/serviceWalkIn/serviceReply.component';
export * from './transaction/getBillDiscountApproval/getBillDiscountApproval.component';
export * from './transaction/getBillDiscountApproval/discountApproval.component';
export * from './transaction/backupFollowUpClient/backupFollowUpClient.component';

export * from './home/dashboard.component';

export * from './dataCorrection/voucherDetails/voucher.component';
export * from './dataCorrection/client_reject/client.component';
export * from './dataCorrection/deleteBilling/deleteBilling.component';
export * from './dataCorrection/walkin_trail_testing/datechange.component';
export * from './dataCorrection/stockUpdate/stocklist.component';
export * from './dataCorrection/walkin_entry_delete/walkindelete.component';
export * from './transaction/appointment/appointment.component';
export * from './transaction/cashOut/cashOut.component';
export * from './transaction/cashOut/addCashOut.component';
export * from './transaction/cashIn/cashIn.component';
export * from './transaction/cashIn/addCashIn.component';
export * from './transaction/expense/expense.component';
export * from './transaction/expense/addExpense.component';
export * from './dataCorrection/walkintestingupdation/walkintestingupdation.component';
export * from './dataCorrection/updateLeads.component';
export * from './master/reference/mergeReference.component';
export * from './master/series/addEditSeries.component';
export * from './master/series/series.component';
export * from './master/power/addEditPower.component';
export * from './master/power/power.component';
export * from './master/performance/addEditPerformance.component';
export * from './master/performance/performance.component';
export * from './master/design/addEditDesign.component';
export * from './master/design/design.component';
export * from './master/battery/battery.component';
export * from './master/battery/addEditBattery.component';
export * from './master/hsncode/addEditHsn.component';
export * from './master/hsncode/hsn.component';
export * from './transaction/salesReturn/machineReturnApproval.component';
export * from './dataCorrection/client_history/client_history.component';
export * from './common/trailModalDet.component';
export * from './master/couponPoints/couponPoints.component';
export * from './master/couponPoints/addEditCouponPoints.component';
export * from './master/doctor/doctor.component';
export * from './master/doctor/addEditDoctor.component';
export * from './master/ledgerMaster/ledgerMaster.component';
export * from './master/ledgerMaster/addEditLedgerMaster.component';
export * from './master/expenseType/expenseType.component';
export * from './master/expenseType/addEditExpenseType.component';
export * from './master/octType/octType.component';
export * from './master/octType/addEditOctType.component';
export * from './master/doctorIncentive/doctorIncentive.component';
export * from './master/doctorIncentive/addEditDoctorIncentive.component';
export * from './master/doctorIncentiveTesting/doctorIncentiveTesting.component';
export * from './master/doctorIncentiveTesting/addEditDoctorIncentiveTesting.component';
export * from './master/promoType/promoType.component';
export * from './master/promoType/addEditPromoType.component';
export * from './master/promoReference/promoReference.component';
export * from './master/promoReference/addEditPromoReference.component';
export * from './master/unsoldDescription/unsoldDescription.component';
export * from './master/unsoldDescription/addEditUnsoldDescription.component';
export * from './master/haModelColor/haModelColor.component';
export * from './master/haModelColor/addEditHaModelColor.component';
export * from './master/couponCode/couponCode.component';
export * from './master/couponCode/addEditCouponCode.component';
export * from './transaction/transferCouponCode/transferCouponCode.component';
export * from './transaction/transferCouponCode/addEditTransferCouponCode.component';
export * from './transaction/couponCodeClient/couponCodeClient.component';
export * from './transaction/couponCodeClient/addEditCouponCodeClient.component';
export * from './transaction/campPromoUpload/campPromoUpload.component';
export * from './transaction/campPromoUpload/campPromoUpload.component';
export * from './dataCorrection/tallySyncStatus/tallySyncStatus.component';
export * from './master/telecallerMaster/telecallerMaster.component';
export * from './master/telecallerMaster/addEditTelecaller.component';
export * from './master/telecallerSlotMaster/telecallerSlotMaster.component';
export * from './master/telecallerSlotMaster/addEditTelecallerSlot.component';
export * from './transaction/assignTelecaller/assignTelecaller.component';
export * from './reports/phoneTrackingFollowupChange/phoneTrackingFollowupChange.component';
export * from './transaction/telecallerTempAssign/telecallerTempAssign.component';
export * from './reports/sharyxCallHistory/sharyxCallHistory.component';
export * from './reports/sharyxWhatsappResponse/sharyxWhatsappResponse.component';
export * from './master/aiStatus/aiStatus.component';
export * from './master/aiStatus/addEditAiStatus.component';
export * from './master/aiCallConfig/aiCallConfig.component';
export * from './master/aiCallConfig/addEditAiCallConfig.component';
export * from './master/aiFollowupConfig/aiFollowupConfig.component';
export * from './master/aiFollowupConfig/addEditAiFollowupConfig.component';
export * from './master/aiTrackDay/aiTrackDay.component';
export * from './master/aiTrackDay/addEditAiTrackDay.component';
export * from './master/aiSettings/aiSettings.component';
export * from './transaction/walkinApproval/walkinApproval.component';



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/index.ts